/* eslint-disable */
export const pt = {
    'QR код': 'Código QR',
    Бейдж: 'Distintivo',
    'Виджет с картой': 'Widget com mapa',
    Кнопка: 'Botão',
    Ссылка: 'Link',
    'widgetgenerator.erip.tooltip':
        "É um código especial criado e atribuído a cada anúncio publicado online. O código é público, sendo que está disponível para todos os utilizadores online, e está incorporado nos parâmetros do link. Podes encontrar o ERID na tua <a href='https://distribution.yandex.ru/v2/create/partner/go?utm_source=widget_generator'>conta</a> Yandex Distribution",
    'widgetgenerator.legal.url.yandex': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.legal.url.yango': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.modal.continue': 'Continuar',
    'widgetgenerator.modal.message':
        'Widgets do tipo "Widget com mapa" não são suportados para esta morada, utiliza um formato de widget diferente',
    'widgetgenerator.yandex.badge.orderInYandex': 'Pedir com Yandex Go',
    'widgetgenerator.yandex.defaultAddress': 'Moscovo, Federação Russa, Rua Lva Tolstogo, 16.',
    'widgetgenerator.yango.badge.getRidetitle': 'Pedir viagem',
    'widgetgenerator.yango.badge.orderInYango': 'Pedir com Yango',
    'widgetgenerator.yango.defaultAddress':
        'Deira, Dubai, Emirados Árabes Unidos, Aeroporto Internacional do Dubai',
    Адрес: 'Morada',
    'Адрес сайта или CLID партнерской программы': 'Site ou CLID do programa do parceiro',
    'Без адреса': 'Nenhuma morada',
    Бизнес: 'Business',
    'Введите авторизационные данные для доступа к API. Получить их можно':
        'Introduz as credenciais de acesso à API. Podes obtê-las',
    'Вызвать такси': 'Pedir viagem',
    'Генератор виджета': 'Gerador de widget',
    'Доехать на такси': 'Obter uma viagem',
    Заголовок: 'Título',
    Загрузить: 'Carregar',
    Комфорт: 'Comfort',
    Копировать: 'Copiar',
    Куда: 'Para',
    'Маршрут, встроенный в ссылку': 'Rota incorporada no link',
    Минивен: 'Minivan',
    'Нажимая «Получить код» вы соглашаетесь с': 'Ao pressionares "Obter código" aceitas os',
    'Невозможно выбрать тариф: регион не поддерживается':
        'Classe de serviço indisponível: região não suportada',
    'Неправильный адрес': 'Morada inválida',
    'Новый виджет': 'Novo widget',
    Откуда: 'De',
    Подзаголовок: 'Subtítulo',
    'Получить код': 'Obter código',
    'Скачать QR код': 'Baixar código QR',
    'Скопируйте код и установите на сайте': 'Copia o código e incorpora-o no teu site',
    Стиль: 'Estilo',
    Стоимость: 'Preço',
    Тариф: 'Classe de serviço',
    'Текст успешно скопирован': 'Texto copiado',
    'Указанный адрес': 'Morada introduzida',
    'Фоновое изображение': 'Imagem de fundo',
    Цена: 'Preço',
    Эконом: 'Economy',
    'Это поле обязательно': 'Campo obrigatório',
    'оставив заявку': 'ao enviares um pedido',
    'условиями использования': 'Termos de Utilização',
};
